import React, { ComponentType, ReactNode } from 'react';
import {
    SvgIconProps,
    ListItemButton,
    ListItem,
    ListItemIcon,
    checkboxClasses,
    ListItemProps,
} from '@mui/material';

import { Check24 } from '../../../icons';
import { Typography, TypographyProps } from '../../Typography';
import { Stack } from '../../Stack';
import { Checkbox } from '../../Checkbox';


export type DropdownOption = {
    label: ReactNode;
    value: any;
    description?: ReactNode;
    icon?: ComponentType<SvgIconProps>;
};

export type ItemProps = Pick<ListItemProps, 'sx'> & {
    data: DropdownOption;
    onSelect: (data: DropdownOption) => void;
    isSelected?: boolean;
    isMulti?: boolean;
    itemTypographyProps?: TypographyProps;
};

export const Item = React.memo<ItemProps>(
    ({ data, onSelect, isSelected, isMulti, sx = {}, itemTypographyProps = {} }) => (
        <ListItem disablePadding data-testid={`dropdown-item-${data.value}`}>
            <ListItemButton
                onClick={() => onSelect(data)}
                sx={{
                    py: 3,
                    px: 4,
                    '&:hover': {
                        backgroundColor: 'grayscale.shade5',

                        [`& .${checkboxClasses.root} > span`]: {
                            borderColor: 'grayscale.shade80',
                        },
                    },
                    ...sx,
                }}
            >
                {data.icon && (
                    <ListItemIcon sx={{ minWidth: 'auto', mr: 4 }}>
                        <data.icon
                            sx={({ spacing }) => ({
                                width: spacing(6),
                                height: spacing(6),
                            })}
                        />
                    </ListItemIcon>
                )}
                <Stack flex='1'>
                    <Typography variant='mediumBody2' color='grayscale.shade95' {...itemTypographyProps}>
                        {data.label}
                    </Typography>
                    {data.description && (
                        <Typography
                            variant='regularCaption1'
                            color='grayscale.shade85'
                        >
                            {data.description}
                        </Typography>
                    )}
                </Stack>
                {isMulti && (
                    <ListItemIcon sx={{ ml: 4, minWidth: 'auto' }}>
                        <Checkbox
                            color='primary'
                            checked={isSelected}
                            onChange={() => onSelect(data)}
                        />
                    </ListItemIcon>
                )}
                {!isMulti && isSelected && (
                    <ListItemIcon sx={{ ml: 4, minWidth: 'auto' }}>
                        <Check24
                            sx={({ spacing }) => ({
                                width: spacing(6),
                                height: spacing(6),
                                color: 'general.primary50',
                            })}
                        />
                    </ListItemIcon>
                )}
            </ListItemButton>
        </ListItem>
    ),
);
